import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { receiptQueryOptions } from '../../../../features/sales/queries'

export const Route = createFileRoute('/_app/receipts/$receiptId')({
  staticData: { crumb: 'receipt' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  loader: ({ context, params }) => context.queryClient.ensureQueryData(receiptQueryOptions(params.receiptId)),
  component: Outlet,
})
